/**
 * Vietnamese translations (primary / default locale).
 */
export const vi = {
  app: {
    importTitle: "Nhập Excel",
    printTitle: "Xuất In",
    enterpriseEdition: "Printer",
    navPrintExport: "Xuất In",
    navImportData: "Nhập Dữ liệu",
    language: "Ngôn ngữ",
  },
  common: {
    back: "Quay lại",
    continue: "Tiếp tục",
    cancel: "Hủy",
    save: "Lưu",
    reset: "Đặt lại",
    dismiss: "Đóng",
    error: "Lỗi",
    none: "— Không —",
    required: "Bắt buộc",
    row: "Dòng",
    rows: "dòng",
    columns: "cột",
    page: "Trang",
    pages: "trang",
    of: "/",
    more: "thêm",
    skipped: "bỏ qua",
    portrait: "Dọc",
    landscape: "Ngang",
  },
  importPage: {
    importComplete: "Nhập hoàn tất",
    importedRows: "Đã nhập thành công {count} dòng.",
    failedRows: "{count} dòng thất bại.",
  },
  importWizard: {
    steps: {
      upload: "Tải lên",
      sheet: "Sheet",
      mapping: "Ánh xạ",
      validate: "Kiểm tra",
      preview: "Xem trước",
      import: "Nhập",
    },
    parsingWorkbook: "Đang đọc workbook...",
    parseError: "Lỗi đọc file",
    fileLoaded: "Đã tải file thành công",
    sheetsRows: "{sheets} sheet · {rows} dòng tổng cộng.",
    validationResults: "Kết quả kiểm tra",
    revalidate: "Kiểm tra lại",
    fixErrorsFirst: "Sửa lỗi trước",
    previewImport: "Xem trước nhập",
    importPreview: "Xem trước dữ liệu nhập",
    reviewBeforeCommit: "Xem lại dữ liệu trước khi xác nhận nhập. {count} dòng sẽ được nhập.",
    importData: "Nhập dữ liệu",
    readyToImport: "Sẵn sàng nhập",
    rowsWillBeSubmitted: "{count} dòng sẽ được gửi lên máy chủ.",
    importing: "Đang nhập...",
    confirmImport: "Xác nhận nhập",
    backToPreview: "Quay lại xem trước",
    sendingToServer: "Đang gửi dữ liệu lên máy chủ...",
    importFailed: "Nhập thất bại",
    importSuccessful: "Nhập thành công",
    rowsImported: "Đã nhập thành công {count} dòng.",
    startOver: "Bắt đầu lại",
    validate: "Kiểm tra",
  },
  upload: {
    title: "Tải lên file Excel",
    description: "Hỗ trợ .xlsx, .xls và .csv tối đa {max} MB. Kéo thả hoặc bấm để chọn file.",
    dragDrop: "Kéo & thả file Excel của bạn",
    dropHere: "Thả file vào đây",
    orBrowse: "hoặc bấm để chọn file",
    unsupportedType: "Định dạng không hỗ trợ. Vui lòng tải file .xlsx, .xls hoặc .csv.",
    tooLarge: "File quá lớn. Kích thước tối đa là {max} MB.",
  },
  template: {
    selectTitle: "Chọn mẫu nhập liệu",
    selectDesc: "Chọn mẫu khớp với cấu trúc file Excel của bạn.",
    sheetsColumns: "{sheets} sheet · {columns} cột",
    required: "(bắt buộc)",
    configured: "{label} — đã cấu hình {sheets} sheet.",
    formulaEnabled: "(bật giữ công thức)",
    mapSheets: "Ánh xạ Sheet",
    mapSheetsDesc: "Ghép từng sheet của mẫu với sheet tương ứng trong workbook.",
    requiredNotMatched: "Có sheet bắt buộc chưa được ghép.",
    selectSheet: "— Chọn sheet —",
    employee: "Nhập nhân viên",
    product: "Danh mục sản phẩm",
    inventory: "Nhập tồn kho",
  },
  mapping: {
    title: "Ánh xạ cột",
    description: "Ghép cột mẫu với cột trong workbook. Các cột tự khớp được đánh dấu.",
    loadProfile: "Tải hồ sơ đã lưu",
    resetToAuto: "Đặt lại tự động",
    reset: "Đặt lại",
    saveProfile: "Lưu hồ sơ",
    autoMapped: "{count} tự khớp",
    manual: "thủ công",
    unmapped: "{count} chưa khớp",
    auto: "tự động",
    requiredMark: "* bắt buộc",
    selectColumn: "Chọn cột workbook",
    notMapped: "— Chưa ánh xạ —",
    saveProfileTitle: "Lưu hồ sơ ánh xạ",
    profilePlaceholder: "Tên hồ sơ (vd: Nhập nhân viên hàng tháng)",
    savedProfiles: "Hồ sơ đã lưu",
    unmappedHint: "{count} cột bắt buộc chưa được ánh xạ. Hãy ánh xạ trước khi kiểm tra.",
  },
  validation: {
    totalRows: "Tổng dòng",
    valid: "Hợp lệ",
    errors: "Lỗi",
    warnings: "Cảnh báo",
    filter: "Lọc:",
    all: "Tất cả",
    error: "Lỗi",
    warning: "Cảnh báo",
    info: "Thông tin",
    group: "Nhóm:",
    byCode: "Mã",
    byColumn: "Cột",
    byRow: "Dòng",
    issues: "{count} vấn đề",
    rows: "Dòng:",
    noIssues: "Không có vấn đề với bộ lọc hiện tại.",
    value: "Giá trị:",
    rowLabel: "Dòng {row}",
  },
  preview: {
    status: "Trạng thái",
    showing: "Hiển thị {count} dòng",
    valid: "{count} hợp lệ",
    warning: "{count} cảnh báo",
    error: "{count} lỗi",
    noData: "Không có dữ liệu để xem trước.",
    backToData: "‹ Dữ Liệu & Nhóm",
    dataLabel: "Dữ liệu",
    noExcel: "Chưa có Excel",
    templateLabel: "Template",
    noTemplate: "Chưa có mẫu",
    paperLabel: "Khổ giấy",
    willPrintLabel: "Sẽ in",
    pages: "{count} trang",
    collapsePanel: "Thu gọn panel",
    expandPanel: "Mở panel",
  },
  printWizard: {
    steps: {
      upload: "Tải lên",
      design: "Thiết kế",
      bind: "Gán cột",
      rows: "Ánh xạ dòng",
      preview: "Xem trước & Xuất",
    },
    uploadTitle: "Tải lên file Excel",
    paperSize: "Khổ giấy:",
    uploadDesc:
      "Tải file Excel (.xlsx, .xls, .csv). Hệ thống sẽ tự đọc tên sheet và tiêu đề cột để dựng mẫu.",
    parsingFile: "Đang đọc file...",
    dropExcel: "Thả file Excel vào đây",
    orBrowseFormats: "hoặc bấm để chọn — .xlsx, .xls, .csv",
    sheetToUse: "Sheet sử dụng:",
    sheetMeta: "{name} ({rows} dòng, {cols} cột)",
    columnsRows: "{cols} cột · {rows} dòng",
    moreColumns: "+{count} thêm",
    orImportTemplate: "hoặc nhập mẫu đã lưu:",
    loadTemplateJson: "Tải Template JSON",
    continueToDesign: "Tiếp tục thiết kế",
    designTitle: "Thiết kế mẫu",
    columnsFromFile: "{count} cột từ file",
    regenerate: "Tạo lại",
    changeFile: "Đổi file",
    continueToBind: "Tiếp tục gán cột",
    bindTitle: "Gán trường mẫu với cột Excel",
    sheetBadge: "Sheet: {name}",
    tablePage: "Trang",
    tableField: "Trường",
    tableType: "Loại",
    tableBoundColumn: "Cột gán",
    tableTransform: "Biến đổi",
    tableFallback: "Giá trị mặc định",
    selectColumn: "Chọn cột...",
    transformNone: "Không",
    transformUpper: "IN HOA",
    transformLower: "in thường",
    transformTrim: "Xóa khoảng trắng",
    fallbackPlaceholder: "giá trị mặc định",
    unboundFields: "{count} trường chưa gán",
    unboundDesc: "{fields} sẽ trống trên bản in.",
    andMore: " và {count} trường nữa",
    continueToRowMapping: "Tiếp tục ánh xạ dòng",
    rowMappingTitle: "Ánh xạ Dòng → Trang",
    splitByColumn: "Tách trang theo cột",
    splitDesc:
      "Nếu một dòng có nhiều mục (vd: Số kiện = 3), tách thành nhiều trang — mỗi mục một trang (1/3, 2/3, 3/3).",
    splitColumn: "Cột tách:",
    noSplit: "— Không tách —",
    noSplitPlaceholder: "Không tách — một trang mỗi dòng",
    willSplitBy: "Dòng sẽ được tách theo: {column}",
    splitPreview: "Xem trước tách:",
    splitItems: "{n} mục: {rows} dòng → {pages} trang",
    pagesPerRecord: "Số trang mỗi bản ghi:",
    maxPages: "(tối đa: {max})",
    previewFirstRows: "Xem trước — 3 dòng đầu ánh xạ sang trang",
    summary: "Tóm tắt:",
    summaryWithData: "{pages} trang tổng cộng từ {rows} dòng{split}",
    withSplit: " (có tách)",
    noDataRows: "Không có dòng dữ liệu",
    continueToPreview: "Tiếp tục xem trước",
    previewExportTitle: "Xem trước & Xuất",
    editTemplate: "Sửa mẫu",
    noDataTitle: "Không có dữ liệu",
    noDataDesc: "File Excel không có dòng dữ liệu để in. Hãy tải file có dữ liệu ở bước đầu.",
    pleaseUploadFirst: "Vui lòng tải file Excel trước.",
    invalidTemplate: "File mẫu không hợp lệ. Cần định dạng JSON.",
    failedParse: "Không đọc được file",
    printName: "In – {name}",
    pageLabel: "Trang {n}",
  },
  canvas: {
    tools: {
      select: "Chọn & di chuyển đối tượng",
      text: "Bấm để thêm trường văn bản",
      line: "Kéo để vẽ đường kẻ",
      checkbox: "Bấm để thêm ô tích",
      label: "Bấm để thêm nhãn tĩnh",
      pan: "Di chuyển canvas",
    },
    textField: "Trường văn bản",
    label: "Nhãn",
    switchLandscape: "Chuyển sang Ngang",
    switchPortrait: "Chuyển sang Dọc",
    zoomOut: "Thu nhỏ",
    zoomIn: "Phóng to",
    fit: "Vừa",
    resetZoom: "Đặt lại 100%",
    pageOf: "Trang {current} / {total}",
    addPage: "Thêm trang",
    templateProperties: "Thuộc tính mẫu",
    templateName: "Tên mẫu",
    pagesPerRecord: "Số trang mỗi bản ghi",
    sheetFields: "Cột từ Sheet",
    filterColumns: "Lọc cột...",
    clickColumnHint: "Bấm một cột để thêm trường đã gán lên canvas",
    fieldProperties: "Thuộc tính trường",
    fieldLabel: "Nhãn trường",
    type: "Loại",
    fontSize: "Cỡ chữ",
    lineHeight: "Chiều cao dòng",
    color: "Màu",
    fontFamily: "Phông chữ",
    textAlign: "Căn chữ",
    boundColumn: "Cột gán",
    transform: "Biến đổi",
    fallbackValue: "Giá trị mặc định",
    shownWhenEmpty: "Hiện khi trống",
    selectObject: "Chọn một đối tượng trên canvas để sửa thuộc tính",
    templateFile: "File mẫu",
    importTemplate: "Nhập mẫu",
    exportTemplate: "Xuất mẫu",
    untitled: "Mẫu chưa đặt tên",
  },
  printPreview: {
    prev: "Trước",
    next: "Sau",
    pageOf: "Trang {current} / {total}",
    row: "Dòng {n}",
    generating: "Đang tạo...",
    downloadPdf: "Tải PDF",
    print: "In",
    unboundFields: "Trường chưa gán",
    unboundDesc:
      "{count} trường trên các trang {details} — chưa gán cột. Các trường này sẽ trống.",
    noPagesTitle: "Không có trang để xem trước",
    noPagesDesc: "Thêm dòng dữ liệu và đảm bảo mẫu đã gán cột.",
    footerSummary: "{rows} dòng × {pagesPerRecord} trang/dòng = {total} trang tổng cộng",
    allBound: "Tất cả trường đã gán",
    unboundCount: "{count} chưa gán",
    pdfFailed: "Tạo PDF thất bại",
    printFailed: "In thất bại",
  },
  validator: {
    required: '"{header}" là bắt buộc.',
    duplicateWithFirst: 'Giá trị trùng "{value}" – lần đầu ở dòng {row}.',
    duplicate: 'Giá trị trùng "{value}".',
    pattern: '"{value}" không khớp mẫu: {pattern}',
    notANumber: '"{value}" không phải số hợp lệ.',
    minValue: "Giá trị tối thiểu là {min}, nhận được {num}.",
    maxValue: "Giá trị tối đa là {max}, nhận được {num}.",
    invalidDate: '"{value}" không phải ngày hợp lệ.',
    enum: '"{value}" không nằm trong danh sách cho phép: {list}.',
  },
  parser: {
    couldNotRead: "Không đọc được file. File có thể bị hỏng hoặc không phải Excel/CSV hợp lệ.",
    noSheets: "Workbook không có sheet nào.",
  },
  recentJobs: {
    title: "Lịch sử in gần đây",
    clearAll: "Xoá toàn bộ",
    empty: "Chưa có tác vụ in/xuất nào được ghi.",
    remove: "Xoá mục này",
    template: "Mẫu",
  },
  toasts: {
    excelLoaded: "Đã tải Excel thành công",
    excelLoadFailed: "Tải Excel thất bại",
    templateLoaded: "Đã tải template",
    templateParseFailed: "Đọc template thất bại",
    renderDone: "Đã dựng xong bản xem trước",
    renderFailed: "Dựng bản xem trước thất bại",
    exportPdfSingle: "Xuất PDF trang hiện tại",
    exportPdfAll: "Xuất PDF tất cả trang",
    exportZip: "Xuất ZIP từng phiếu",
    print: "In",
    exportOk: "Xuất thành công",
    exportFailed: "Xuất thất bại",
    printStarted: "Đang mở hộp in…",
    printFailed: "In thất bại",
    pagesOverflow: "{count} trang bị tràn (sẽ tự co lại)",
    fieldsUnbound: "{count} trường chưa gán cột",
  },
  dataStep: {
    uploadTitle: "Tải Dữ Liệu",
    uploadDesc: "Chọn file Excel, sau đó chọn sheet cần xử lý.",
    changeFile: "Thay Đổi File Excel",
    uploadLabel: "Tải Dữ Liệu",
    dropHint: "Kéo thả file vào đây hoặc bấm để chọn (.xlsx, .xls, .csv)",
    roleTitle: "Nhận diện kiểu workbook macro",
    sheetLabel: "Sheet dữ liệu (nguồn bind)",
    roleData: " · dữ liệu",
    rolePrint: " · mẫu in Excel",
    colsRows: "{cols} cột · {rows} dòng",
    groupTitle: "Nhóm Dữ Liệu",
    groupDesc: "Chọn <strong>cột nhóm chính</strong> — mỗi nhóm thành một chứng từ (trang in).",
    waitingData: "Chờ dữ liệu",
    waitingDesc: "Tải file Excel ở cột bên trái, chọn sheet, rồi chọn cột nhóm để tạo chứng từ.",
    noGroup: "-- Chưa chọn --",
    groupPlaceholder: "Chọn cột nhóm chính",
    searchIn: "Tìm trong {count} cột…",
    confirmChangeGroup: "Đổi cột nhóm chính sẽ làm mới danh sách trang in (mất các lựa chọn hiện tại). Tiếp tục?",
    groupExample: "Ví dụ: chọn <code>Mã điểm giao</code> để mỗi điểm giao hàng trở thành một phiếu in.",
    rowsToDocs: "{rows} dòng → {groups} chứng từ",
    oneDocOnePage: "(1 chứng từ = 1 trang in)",
    rowsCount: "{count} dòng",
    moreDocs: "+ {count} chứng từ nữa…",
    lookupTitle: "Lấy Thêm Dữ Liệu Từ Sheet Phụ",
    lookupDesc: "Sheet chính <strong>{sheet}</strong> là nguồn bind. Nếu template cần trường nằm ở sheet khác, chọn sheet phụ và khóa nối — hệ thống chỉ gợi ý cột trùng tên, bạn phải xác nhận.",
    noLookup: "Không dùng sheet phụ",
    noLookupItem: "-- Không dùng sheet phụ --",
    joinBy: "nối theo",
    primaryCol: "Cột trên sheet chính",
    secondaryCol: "Cột trên sheet phụ",
    joinCandidates: "Có {count} cột trùng tên khả dĩ ({cols}) — hãy xác nhận đúng khóa nối.",
    joinIncomplete: "Chưa chọn đủ khóa nối — các trường từ sheet phụ chưa dùng được.",
    joinedCols: "Đã thêm {count} cột từ sheet phụ: {cols}",
    readyForTemplate: "Đã chọn nhóm · sẵn sàng sang mẫu template",
    chooseGroup: "Chọn cột nhóm chính để tiếp tục",
    uploadFirst: "Tải Excel trước khi tiếp tục",
    continuePreview: "Tiếp tục: Xem Trước & In",
  },
  picker: {
    title: "Thư viện template",
    desc: "Chọn mẫu hệ thống hoặc quản lý thư viện .docx của bạn. Thêm file vào Của tôi, gắn tag, rồi bấm Dùng mẫu này khi cần in.",
    searchPlaceholder: "Tìm kiếm mẫu theo tên hoặc mô tả…",
    dropTitle: "Kéo thả file .docx vào bất kỳ đâu trong thư viện, hoặc bấm để chọn",
    dropText: "Kéo thả <code class=\"rounded bg-muted px-1\">.docx</code> vào bất kỳ đâu · hoặc bấm để thêm vào thư viện",
    dropOverlay: "Thả file .docx để thêm vào thư viện",
    dropOverlayHint: "Có thể thả nhiều file cùng lúc",
    tabAll: "Tất cả",
    tabSystem: "Mẫu hệ thống",
    tabMy: "Của tôi",
    navLibrary: "Thư viện",
    addToLibrary: "Thêm .docx",
    addToLibraryHint: "Lưu vào thư viện Của tôi (không đổi template đang dùng)",
    libraryCount: "{count} mẫu",
    allCount: "Tất cả ({count})",
    addTagTitle: "Thêm tag",
    addTag: "+ Tag",
    saveCurrent: "Lưu template hiện tại làm template của tôi",
    emptyTitle: "Thư viện trống",
    emptyDesc: "Thêm file .docx để quản lý, gắn tag và dùng lại khi in chứng từ.",
    sectionMy: "Của tôi",
    sectionSystem: "Hệ thống",
    noMatch: "Không tìm thấy mẫu phù hợp với \"{query}\".",
    useThis: "Dùng mẫu này",
    preview: "Xem trước",
    previewBig: "Xem trước {name} lớn hơn",
    downloadFile: "Tải file {name}",
    footer: "{count} mẫu · Xem trước · Dùng mẫu này",
    close: "Đóng",
    downloadDocx: "Tải .docx",
    useTemplate: "Dùng mẫu {name}",
    editedBadge: "Đã chỉnh",
    badgeSystem: "Hệ thống",
    badgeMine: "Của tôi",
    selectToPreview: "Chọn một mẫu để xem trước chi tiết",
    backToList: "Quay lại danh sách",
    newTagPlaceholder: "Tên tag mới",
    rename: "Đổi tên",
    renameTemplate: "Đổi tên template {name}",
    deleteTemplate: "Xóa template",
    deleteTemplateName: "Xóa template {name}",
    untag: "Bỏ tag {name}",
    tag: "Gắn tag {name}",
    untagFrom: "Bỏ tag {name} khỏi {tpl}",
    tagTo: "Gắn tag {name} cho {tpl}",
    addedToLibrary: "Đã thêm vào thư viện",
  },
  editor: {
    close: "Đóng",
    saveAndPreview: "Lưu & Xem Kết Quả",
    splitPage: "Tách trang",
    newText: "Văn bản mới",
    addedText: "Đã thêm văn bản",
    addedTextDesc: "Kéo để định vị, chọn để chỉnh nội dung và định dạng.",
    insertedImage: "Đã chèn ảnh",
    insertedImageDesc: "Ảnh được nhúng base64 nên giữ nguyên khi in/PDF.",
    deleted: "Đã xóa",
    deletedDesc: "Thành phần đã được gỡ khỏi trang.",
    pasteHint: "Dán (Ctrl+V) vào canvas Word",
    reloadConfirm: "Tải lại template gốc?\n\nMọi thay đổi chưa lưu ở trang này (văn bản, bảng, dữ liệu) sẽ bị mất. Tiếp tục?",
    reloaded: "Đã tải lại template gốc",
    zoomOut: "Thu nhỏ",
    resetZoom: "Đặt lại 100%",
    zoomIn: "Phóng to",
    editOn: "Soạn Thảo",
    editOff: "Tắt Soạn Thảo",
    reloadTemplate: "Tải lại template gốc",
    commitEdits: "Ghi chỉnh sửa canvas vào file Word",
    downloadDocx: "Tải file .docx",
    openPanel: "Mở panel",
    collapsePanel: "Thu gọn panel",
    lockAndPreview: "chốt & sang xem trước",
  },
  tour: {
    back: "Quay lại",
    next: "Tiếp",
    skip: "Bỏ qua",
    finish: "Xong",
    close: "Đóng",
    replay: "Tour nhanh",
    openDocs: "Tài liệu hướng dẫn",
    menuTitle: "Trợ giúp",
    dataWelcomeTitle: "Chào mừng đến In Ấn Chứng Từ",
    dataWelcomeBody: "Tạo phiếu/hóa đơn từ Excel + mẫu Word trong 2 bước: chuẩn bị dữ liệu, rồi xem trước & in.",
    dataExcelTitle: "1. Tải Excel",
    dataExcelBody: "Kéo thả hoặc chọn file .xlsx chứa dữ liệu chứng từ. Hệ thống tự nhận sheet và cột.",
    dataGroupTitle: "2. Cột nhóm phiếu",
    dataGroupBody: "Chọn cột nhóm (vd. Số PO, Mã phiếu) — mỗi giá trị = một chứng từ in riêng.",
    dataContinueTitle: "3. Sang xem trước",
    dataContinueBody: "Khi đã có Excel và cột nhóm, bấm Tiếp tục để chọn mẫu template và in/PDF.",
    dataHelpTitle: "Cần giúp thêm?",
    dataHelpBody: "Mở menu Trợ giúp bất cứ lúc nào để chạy lại tour nhanh hoặc đọc tài liệu đầy đủ.",
    previewWelcomeTitle: "Bước 2 — Xem trước & In",
    previewWelcomeBody: "Chọn mẫu, khổ giấy, tick phiếu cần in, rồi xuất PDF / in / ZIP.",
    previewTemplateTitle: "Thư viện template",
    previewTemplateBody: "Bấm Template để mở thư viện: Tất cả · Của tôi · Mẫu hệ thống. Kéo thả .docx để thêm mẫu.",
    previewPaperTitle: "Khổ giấy & máy in",
    previewPaperBody: "Chọn A4/A5… và hướng Dọc/Ngang. Có thể lưu hồ sơ máy in để dùng lại.",
    previewListTitle: "Danh sách phiếu in",
    previewListBody: "Bật/tắt từng phiếu. Chỉ phiếu được chọn mới vào PDF/In/ZIP.",
    previewExportTitle: "Xuất & In",
    previewExportBody: "Xuất PDF trang/tất cả, In trình duyệt, hoặc ZIP theo phiếu. Xong — sẵn sàng làm việc!",
  },
} as const;

type DeepStringify<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends ReadonlyArray<infer U>
      ? DeepStringify<U>[]
      : T[K] extends object
        ? DeepStringify<T[K]>
        : T[K];
};

export type Messages = DeepStringify<typeof vi>;
